import { formatReceivedAmount } from '@/shared/lib';
import { useTranslation } from 'react-i18next';

type Props = {
  code: string;
  available: number;
  onClick: () => void;
};

export const AssetFromAvailableDescription = ({
  code,
  available,
  onClick,
}: Props) => {
  const { t } = useTranslation();

  return (
    <span className="cursor-pointer" onClick={onClick}>
      {t('common.available')}: {formatReceivedAmount(available)} {code}
    </span>
  );
};
